// extracted by mini-css-extract-plugin
module.exports = {"toolArea":"Features_toolArea__2Ub8y","tools":"Features_tools__3GJnm"};